import React, { useState } from 'react';
import { Dropdown } from 'flowbite-react';
import { UIApplicationCardState, UIExtendedApplication } from 'types';
import {
	optOutOfApplicationProcess,
	requestInterviewReschedule,
	requestOptingOutOfApplicationProcess,
} from 'src/apis/application';
import { useMutation, useQueryClient } from 'react-query';
import { useToast } from 'src/context/ToastProvider';
import OptOutModal from './OptOutModal';
import classNames from 'classnames';
import { BsThreeDots } from 'react-icons/bs';

interface Props {
	applicationCardState: UIApplicationCardState;
	application: UIExtendedApplication;
}

const ThreeDotMenu = ({ applicationCardState, application }: Props) => {
	const [showOptOutModal, setShowOptOutModal] = useState(false);

	const toast = useToast();
	const queryClient = useQueryClient();
	const [requestOptingOutOfApplicationProcessLoading, setRequestOptingOutOfApplicationProcessLoading] = useState(false);
	const [requestInterviewRescheduleLoading, setRequestInterviewRescheduleLoading] = useState(false);

	const requestOptingOutOfApplicationProcessMutation = useMutation(
		['optOutOfApplicationProcess'],
		requestOptingOutOfApplicationProcess,
		{
			onSuccess() {
				toast({
					title: 'You have successfully requested to opt out of the application process',
					type: 'success',
				});
				queryClient.refetchQueries(['getAllApplications']);
				setRequestOptingOutOfApplicationProcessLoading(false);
			},
			onError(error: Error) {
				setRequestOptingOutOfApplicationProcessLoading(false);
				toast({
					title: `Error while requesting opt out of the application process: ${error.message}`,
					type: 'error',
				});
			},
		},
	);
	const requestInterviewRescheduleMutation = useMutation(['optOutOfApplicationProcess'], requestInterviewReschedule, {
		onSuccess() {
			toast({
				title: 'You have successfully requested for the interview to be reschedule',
				type: 'success',
			});
			queryClient.refetchQueries(['getAllApplications']);
			setRequestInterviewRescheduleLoading(false);
		},
		onError(error: Error) {
			setRequestInterviewRescheduleLoading(false);
			toast({
				title: `Error while requesting reschedule from interview process: ${error.message}`,
				type: 'error',
			});
		},
	});
	const [optOutReason, setOptOutReason] = useState<string>('');
	return (
		<>
			<div
				onClick={e => {
					e.stopPropagation();
				}}
				className={`ml-auto md:block [&_div[data-testid='flowbite-dropdown']]:!border-gray-200 dark:[&_div[data-testid='flowbite-dropdown']]:!border-gray-600 `}
			>
				<Dropdown
					dismissOnClick
					arrowIcon={false}
					inline={true}
					color={'#C7C9D9'}
					className={classNames(
						'navbar-profile-dropdown dark:!border dark:!border-[#5f5f61] dark:!bg-[#1F2A37] !text-[#C7C9D9] font-inter',
					)}
					label={<BsThreeDots className='w-[24px] h-[24px]' />}
				>
					{applicationCardState === UIApplicationCardState.INTERVIEW_ROUND_IN_PROGRESS_CARD && (
						<Dropdown.Item
							onClick={() => {
								requestInterviewRescheduleMutation.mutate({
									applicationId: application._id || '',
									userId: application.user?._id || '',
									remarks: 'Test remarks for interview!',
								});
							}}
							disabled={requestInterviewRescheduleLoading}
						>
							<p className="text-[14px] font-[500] leading-[21px]">Request for Reschedule</p>
						</Dropdown.Item>
					)}
					<Dropdown.Item
						disabled={requestOptingOutOfApplicationProcessLoading}
						onClick={() => {
							setShowOptOutModal(true);
						}}
					>
						<p className="text-[14px] font-[500] leading-[21px]">Opt-out</p>
					</Dropdown.Item>
				</Dropdown>
			</div>
			<OptOutModal
				isOpen={showOptOutModal}
				onClose={() => {
					setShowOptOutModal(false);
				}}
				optOutReason={optOutReason}
				setOptOutReason={setOptOutReason}
				application={application}
				requestOptingOutOfApplicationProcessMutation={requestOptingOutOfApplicationProcessMutation}
			/>
		</>
	);
};

export default ThreeDotMenu;
